<div class="content">
  <div class="content__close svg" (click)="closeDialog()"><img src="assets/icons/general/close.svg" alt="close" /></div>
  <app-introtext *ngIf="!isKids"
    ><h1>{{ 'EXERCISES.EDITOR.header' | translate }}</h1></app-introtext
  >
  <app-introtext *ngIf="isKids"><h1>Erstelle dir eigene Übungsprogramme</h1></app-introtext>
  <app-chips-list class="b2a-exercisesContainer__filter">
    <app-chip (select)="filter()" [selected]="true">{{ 'EXERCISES.categoryAll' | translate }}</app-chip>

    <app-chip (select)="filter(cat)" *ngFor="let cat of mainCategories">{{
      cat.title[translate.currentLang]
    }}</app-chip>
  </app-chips-list>
  <div class="content__innerContainer">
    <app-box
      *ngFor="let ex of exercises | categoryfilter : filterargs"
      [id]="ex._id"
      [boxType]="'ex'"
      [type]="selectedExercises.includes(ex) ? 'remove' : 'add'"
      [preview]="ex.previewUrl"
      [title]="ex.title[translate.currentLang]"
      [selected]="selectedExercises.includes(ex)"
      [categories]="ex.categories"
      (onSelect)="toggleSelection(ex)"
    >
    </app-box>
  </div>
</div>
<app-expansion-panel
  #selection
  [(title)]="currentProgram.title"
  [selectedExercises]="selectedExercises"
  (onRemove)="toggleSelection($event)"
  (onDone)="createNewMyProgram()"
>
</app-expansion-panel>



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/mp-dialog/mp-dialog.component.html